export default __webpack_public_path__ + "static/software_small-bdf86c182de349e4d7a070320175f0e8.jpg";